import {Typography} from '@mui/material';
import {AppointmentBookingEnum, ConfirmationDrawerEnum} from 'main/analytics/gaTagsEnum';
import {Drawer} from 'presentation/components/Drawer';
import {HandleMessage} from 'presentation/components/HandleMessage';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {buildAlertMessageProps} from '../../utils/alertMessage/buildAlertMessageProps';
import {Alert} from './Alert';
import {BeneficiaryInfo} from './BeneficiaryInfo';
import {ChangeBeneficiaryCard} from './ChangeBeneficiaryCard';
import {SimpleConfirmationDrawerProps} from './types';
import {useSimpleConfirmationDrawer} from './useSimpleConfirmationDrawer';

const {title, subtitle, confirmAndContinue, updateInfo} =
	translations['pt-br'].privateFlow.bookingFlow.confirmationDrawer;

function SimpleConfirmationDrawer({
	handleConfirmAndContinue,
	isOpened,
	handleOpen,
	handleClose,
	serviceType,
}: SimpleConfirmationDrawerProps) {
	const {phone, email, handleUpdateInfo, handleContinue, handleCloseAlert, openAlert} =
		useSimpleConfirmationDrawer({handleConfirmAndContinue, handleClose});

	return (
		<Fragment>
			<Drawer.Root
				open={isOpened}
				onClose={handleClose}
				onOpen={handleOpen}
				width="600px"
				customMaxHeight="100%"
				sx={{zIndex: 9000}}
				disableSwipeToOpen>
				<Drawer.Header
					onClose={handleClose}
					title={title}
					closeBtnDataTagId={`${ConfirmationDrawerEnum.CLICK_FECHAR_CONFIRMACAO_DADOS}${serviceType ?? ''}`}
				/>
				<Drawer.Content>
					<Typography variant="body1" sx={{mt: 2, mb: 3}}>
						{subtitle}
					</Typography>
					<ChangeBeneficiaryCard />
					<BeneficiaryInfo
						cellPhone={phone.toString()}
						eMail={email.toString()}
						hasCellPhoneWarn={!phone.hasValue || phone.invalidValue}
						hasEMailWarn={!email.hasValue || email.invalidValue}
					/>
				</Drawer.Content>
				<Drawer.Footer
					secondButtonDataTagId={`${AppointmentBookingEnum.CLICK_CONFIRMAR_CONTINUAR}${serviceType ?? ''}`}
					secondButtonTitle={confirmAndContinue}
					secondButtonOnClick={handleContinue}
					firstButtonDataTagId={`${ConfirmationDrawerEnum.CLICK_ALTERAR_DADOS_PESSOAIS_CONFIRMACAO_DADOS}${serviceType ?? ''}`}
					firstButtonTitle={updateInfo}
					firstButtonOnClick={handleUpdateInfo}
					canStacks
				/>
			</Drawer.Root>
			<Alert
				message={
					<HandleMessage
						{...buildAlertMessageProps({
							hasPhoneValue: phone.hasValue,
							hasEmailValue: email.hasValue,
							isInvalidPhone: phone.invalidValue,
							isInvalidEmail: email.invalidValue,
						})}
					/>
				}
				open={openAlert}
				handleClose={handleCloseAlert}
				handleCallback={handleClose}
			/>
		</Fragment>
	);
}

export {SimpleConfirmationDrawer};
